/*@ngInject*/
const UserPreferencesRepository = function (baseCachedRepository, preferenceModel) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'preferenceRepository';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.processResponseData = function (responseData) {
        preferenceModel.setUserPreferences(responseData);
        return responseData;
    };

    this.loadUserPreferences = function () {
        let url = '/rest/UserPreference',
            cacheKey = 'userPrefs';

        return this.get(cacheKey, url);
    };
};

angular.module('umCore')
    .service('userPreferencesRepository', UserPreferencesRepository);
